import { Controller } from "@hotwired/stimulus"
import { confirmDialog } from "../turbo_confirm"

export default class extends Controller {
  connect() {}

  showModal(event) {
    const imageUrl = event.currentTarget.dataset.paintModalImg_url
    const progressionId = event.currentTarget.dataset.progressionId
    const taskId = event.currentTarget.dataset.taskId
    const canvas = document.getElementById("canvas")
    const context = canvas.getContext("2d")
    context.lineWidth = 2
    context.strokeStyle = "black"
    const image = new Image()
    image.crossOrigin = "anonymous"
    image.src = imageUrl
    image.onload = function () {
      const canvas = context.canvas
      let canvasWidth = 800
      let canvasHeight = 600
      if (window.screen.width < 600) {
        canvasWidth = canvas.width
        canvasHeight = canvas.height
      }
      canvas.width = canvasWidth
      canvas.height = canvasHeight
      const hRatio = canvasWidth / image.width
      const vRatio = canvasHeight / image.height
      const ratio = Math.min(hRatio, vRatio)
      const centerShift_x = (canvasWidth - image.width * ratio) / 2
      const centerShift_y = (canvasHeight - image.height * ratio) / 2
      context.clearRect(0, 0, canvasWidth, canvasHeight)
      context.drawImage(
        image,
        0,
        0,
        image.width,
        image.height,
        centerShift_x,
        centerShift_y,
        image.width * ratio,
        image.height * ratio,
      )

      const modal = document.createElement("div")
      modal.classList.add("paint-modal")

      const closeButton = createCloseButton(canvas, modal, context)
      const saveButton = createSaveButton(canvas, context, modal, taskId, progressionId)

      modal.appendChild(closeButton)
      modal.appendChild(saveButton)
      modal.appendChild(canvas)
      document.body.appendChild(modal)

      // Add both mouse and touch events
      canvas.addEventListener("mousedown", startDrawing)
      canvas.addEventListener("mouseup", stopDrawing)
      canvas.addEventListener("mousemove", draw)

      // Add touch events
      canvas.addEventListener("touchstart", handleTouchStart)
      canvas.addEventListener("touchend", handleTouchEnd)
      canvas.addEventListener("touchmove", handleTouchMove)
    }

    function createCloseButton(canvas, modal, context) {
      const closeButton = document.createElement("button")
      closeButton.classList.add(
        "bg-green-500",
        "hover:bg-green-500",
        "text-white",
        "py-2",
        "px-4",
        "m-6",
        "rounded",
        "text-sm",
      )
      closeButton.innerHTML = "Schließen"
      closeButton.style.position = "absolute"
      closeButton.style.right = "1px"
      closeButton.style.fontSize = "18px"
      closeButton.addEventListener("click", () => {
        closeModal(canvas, modal, context)
      })
      return closeButton
    }

    function closeModal(canvas, modal, context) {
      canvas.classList.remove("is-active")
      canvas.removeEventListener("mousedown", startDrawing)
      canvas.removeEventListener("mouseup", stopDrawing)
      canvas.removeEventListener("mousemove", draw)
      canvas.removeEventListener("touchstart", handleTouchStart)
      canvas.removeEventListener("touchend", handleTouchEnd)
      canvas.removeEventListener("touchmove", handleTouchMove)
      modal.classList.add("hidden")
      context.clearRect(0, 0, canvas.width, canvas.height)
    }

    function createSaveButton(canvas, context, modal, taskId, progressionId) {
      const saveButton = document.createElement("button")
      saveButton.innerHTML +=
        '<button class="bg-green-500 hover:bg-green-500 text-white py-2 px-4 m-6 rounded text-sm">Speichern</button>'
      saveButton.style.fontSize = "18px"

      saveButton.addEventListener("click", async () => {
        const imageData = canvas.toDataURL()
        if (await confirmDialog("Möchten Sie das Bild speichern?")) {
          fetch(`/tasks/${taskId}/progressions/${progressionId}/`, {
            method: "PATCH",
            body: JSON.stringify({ progression: { imageData } }),
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
            },
          })
            .then((response) => {
              if (!response.ok) throw new Error("Bild konnte nicht gespeichert werden")
              alert("Bild erfolgreich gespeichert")
              modal.classList.add("hidden")
              context.clearRect(0, 0, canvas.width, canvas.height)
              document.querySelector("#offcanvas").remove()
            })
            .catch((error) => {
              console.error(error)
              alert("Bild konnte nicht gespeichert werden")
            })
        }
      })

      return saveButton
    }

    let isDrawing = false

    function startDrawing(event) {
      isDrawing = true
      draw(event)
    }

    function stopDrawing() {
      isDrawing = false
      context.beginPath()
    }

    function draw(event) {
      if (!isDrawing) {
        return
      }

      let x, y

      if (event.type === "mousemove") {
        x = event.offsetX
        y = event.offsetY
      } else if (event.type === "touchmove") {
        const rect = canvas.getBoundingClientRect()
        x = event.touches[0].clientX - rect.left
        y = event.touches[0].clientY - rect.top
      }

      context.lineTo(x, y)
      context.stroke()
      context.beginPath()
      context.moveTo(x, y)
    }

    // Touch event handlers
    function handleTouchStart(event) {
      event.preventDefault()
      isDrawing = true
      const rect = canvas.getBoundingClientRect()
      const x = event.touches[0].clientX - rect.left
      const y = event.touches[0].clientY - rect.top
      context.beginPath()
      context.moveTo(x, y)
    }

    function handleTouchEnd(event) {
      event.preventDefault()
      isDrawing = false
      context.beginPath()
    }

    function handleTouchMove(event) {
      event.preventDefault()
      if (!isDrawing) return
      draw(event)
    }
  }
}
